import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store/reducers';

const selectSlice = (state: RootState) => state.snowflakeConfiguration;

const selectGetConnectionConfig = createSelector(
    [selectSlice],
    ({ getConfiguration }) => getConfiguration
);

export const selectGetConnectionConfigIsLoading = createSelector(
    [selectGetConnectionConfig],
    ({ isLoading }) => isLoading
);

export const selectConnectionConfigProperties = createSelector(
    [selectGetConnectionConfig],
    ({ properties }) => properties
);

const selectSetConnectionConfig = createSelector(
    [selectSlice],
    ({ setConfiguration }) => setConfiguration
);

export const selectSetConnectionConfigError = createSelector(
    [selectSetConnectionConfig],
    ({ error }) => error
);

export const selectSetConnectionConfigIsLoading = createSelector(
    [selectSetConnectionConfig],
    ({ isLoading }) => isLoading
);

const selectSetUserCredentials = createSelector(
    [selectSlice],
    ({ setUserCredentials }) => setUserCredentials
);

export const selectSetUserCredentialsError = createSelector(
    [selectSetUserCredentials],
    ({ error }) => error
);
export const selectSetUserCredentialsIsLoading = createSelector(
    [selectSetUserCredentials],
    ({ isLoading }) => isLoading
);

export const selectIsConnectionStatusModalOpen = createSelector(
    selectSlice,
    ({ isConnectionStatusDialogOpen }) => isConnectionStatusDialogOpen
);
